{
  "pages": {
    "leads": {
      "title": "Leads"
    },
    "deals": {
      "title": "Deals"
    },
    "tasks": {
      "title": "Tasks"
    },
    "followups": {
      "title": "Followups",
      "description": "Calls, meetings, reminders and next actions"
    },
    "campaigns": {
      "title": "CRM campaigns"
    },
    "contacts": {
      "title": "Contacts"
    },
    "companies": {
      "title": "Companies"
    },
    "reports": {
      "title": "CRM Reports"
    },
    "setup": {
      "title": "CRM Setup"
    },
    "customers": {
      "title": "Customer 360",
      "description": "Customer 360 — unified Fattah timeline",
      "loading": "Loading customer profile…"
    },
    "dashboard": {
      "title": "CRM Dashboard",
      "description": "Pipeline, leads, and revenue — filtered to records assigned within your visibility",
      "pipelineDetails": "Pipeline details",
      "openDeals": "Open deals",
      "forecastRevenue": "Forecast revenue",
      "wonRevenue": "Won revenue",
      "conversionRate": "Conversion rate",
      "activitiesDue": "Activities due",
      "totalLeads": "Total leads"
    },
    "segmentedOutreachWithEmailSmsAnd": "Segmented outreach with email, SMS, and WhatsApp channels",
    "b2bAccountsWithContactsDealsAnd": "B2B accounts with contacts, deals, and activities",
    "organizationWideCustomerContactsLinkedTo": "Organization-wide customer contacts linked to Customer 360",
    "pipelineKanbanAndDealListWith": "Pipeline kanban and deal list with finance quote integration",
    "createLead": "Create lead",
    "manageLeadIntakeQualificationAndConversion": "Manage lead intake, qualification and conversion",
    "noLeadsYet": "No leads yet",
    "captureLeadsFromCampaignsOrAdd": "Capture leads from campaigns or add them manually to start your pipeline.",
    "pipelineConversionLeadSourceAndSalesperson": "Pipeline, conversion, lead source, and salesperson performance",
    "pipelines": "Pipelines",
    "scoringRules": "Scoring rules",
    "assignmentRules": "Assignment rules",
    "workflowAutomations": "Workflow automations",
    "emailAccountsImapSync": "Email accounts (IMAP sync)",
    "pipelinesScoringAssignmentWorkflowsLeadSources": "Pipelines, scoring, assignment, workflows, lead sources, territories, email sync",
    "openCrmTasksAndFollowUps": "Open CRM tasks and follow-ups for your team"
  },
  "toast": {
    "leadCreated": "Lead created",
    "leadConverted": "Lead converted — deal created",
    "campaignCreated": "Campaign created",
    "campaignLaunched": "Campaign launched",
    "campaignScheduled": "Campaign scheduled",
    "taskCreated": "Task created",
    "taskCompleted": "Task completed",
    "quoteCreated": "Quote created (invoice #{{invoiceId}})",
    "emailSynced": "Synced {{count}} new email activities",
    "gmailConnected": "Gmail connected via XOAUTH2: {{email}}"
  },
  "errors": {
    "leadCreationFailed": "Lead creation failed",
    "leadConversionFailed": "Lead conversion failed",
    "loadPipelineFailed": "Failed to load pipeline",
    "moveDealFailed": "Move deal failed",
    "createQuoteFailed": "Create quote failed",
    "loadCustomer360Failed": "Failed to load Customer 360",
    "createCampaignFailed": "Failed to create campaign",
    "launchFailed": "Launch failed",
    "scheduleDateRequired": "Pick a schedule date/time first",
    "scheduleFailed": "Schedule failed",
    "createFailed": "Create failed",
    "reportsUnavailable": "Reports unavailable",
    "loadSetupFailed": "Failed to load setup",
    "connectEmailFailed": "Failed to connect email account",
    "emailSyncFailed": "Email sync failed",
    "setupFailed": "Setup failed",
    "googleOAuthNotConfigured": "Google OAuth not configured",
    "loadTasksFailed": "Failed to load tasks",
    "createTaskFailed": "Failed to create task",
    "completeTaskFailed": "Failed to complete task",
    "googleOAuthFailed": "Google OAuth failed: {{error}}",
    "oauthConnectFailed": "OAuth connect failed",
    "failedToLoadCampaigns": "Failed to load campaigns",
    "failedToLoadCompanies": "Failed to load companies",
    "failedToLoadContacts": "Failed to load contacts",
    "failedToLoadDeals": "Failed to load deals",
    "failedToLoadCrmLeads": "Failed to load CRM leads"
  },
  "oauth": {
    "connecting": "Connecting Gmail account…"
  },
  "labels": {
    "campaignName": "Campaign name",
    "channel": "Channel",
    "audienceSegment": "Audience segment",
    "scheduleTimeForRowActionsBelow": "Schedule time (for row actions below)",
    "searchContacts": "Search contacts",
    "searchNameOrEmail": "Search name or email",
    "leadSource": "Lead source",
    "leadStatus": "Lead status",
    "leadScore": "Lead score",
    "dealName": "Deal name",
    "expectedRevenue": "Expected revenue",
    "customerName": "Customer name",
    "customerEmail": "Customer email",
    "email": "Email",
    "imapHost": "IMAP host",
    "imapPort": "IMAP port",
    "imapUsername": "IMAP username",
    "imapPassword": "IMAP password",
    "imapPort993": "IMAP port (993)",
    "newTask": "New task"
  },
  "formActions": {
    "convertToDeal": "Convert to deal",
    "createCampaign": "Create campaign"
  },
  "listActions": {
    "newLead": "New lead"
  }
}
